import { useEffect } from "react";
import { clearSession } from "../lib/session";

/**
 * /already-completed — shown when POST /interviews/initiate returned
 * 409 `already_completed` (this user already finished this study). Clears
 * the session so a return visit doesn't get stuck on a stale state. No
 * retry CTA.
 */
export function AlreadyCompleted() {
  useEffect(() => {
    clearSession();
  }, []);

  return (
    <div className="w-full max-w-[560px] mx-auto text-center">
      <h1 className="font-serif text-balance text-[28px] leading-[34px] sm:text-[34px] sm:leading-[42px] lg:text-[40px] lg:leading-[48px] text-center text-surface-ink mb-3 sm:mb-4 mx-auto max-w-[18ch]">
        You're all set
      </h1>
      <p className="text-center text-body-m text-surface-subtle mb-7 sm:mb-9 mx-auto max-w-[48ch] leading-relaxed">
        This email has already completed an interview with Lea. Thanks for
        sharing your experience — your reward is on its way.
      </p>
      <div className="bg-surface rounded-card border border-brand-100 shadow-card p-6 sm:p-7 flex flex-col items-center text-center max-w-[440px] mx-auto">
        <p className="text-body-m text-surface-ink mb-1.5">
          One interview per person.
        </p>
        <p className="text-body-s text-surface-subtle leading-relaxed max-w-[36ch]">
          If you think this is a mistake, reach out at{" "}
          <a
            href="mailto:support@theleaply.com"
            className="font-semibold text-brand-700 hover:underline whitespace-nowrap"
          >
            support@theleaply.com
          </a>
          .
        </p>
      </div>
    </div>
  );
}
